module.exports = __webpack_public_path__ + "static/img/icon-logo.35b06352.png";